import { buildCustomerEmailModel } from './emailModel';
import { escapeEmailText, escapeHtml, formatStoreAddressEmailHtml } from './emailFormatting';
import { formatMoney } from './formatters';

export function buildBundleBuilderEmailPreview({
    activeEmailShell,
    activeTvGiftAdjustment,
    activeTvPriceAdjustment,
    builder,
    mobilityDiscountActive,
    selectedAddons,
    selectedInternet,
    selectedLongDistance,
    selectedMobility,
    selectedPhone,
    selectedSecurity,
    selectedTv,
    billCreditAmount: BILL_CREDIT_AMOUNT = 50
}) {
    const {
        rows,
        warnings: uniqueInternalWarnings,
        homeSubtotal,
        regularTotal,
        totalSavings,
        hasHomeServices,
        billCredit,
        currentMonthlyBill,
        hasCurrentMonthlyBill,
        discountFootnote,
        isInternetOnlyEmail,
        customerIncludedFeatures
    } = buildCustomerEmailModel({
        builder,
        mobilityDiscountActive,
        selectedAddons,
        selectedInternet,
        selectedLongDistance,
        selectedMobility,
        selectedPhone,
        selectedSecurity,
        selectedTv,
        activeTvPriceAdjustment,
        activeTvGiftAdjustment,
        activeEmailShell,
        billCreditAmount: BILL_CREDIT_AMOUNT
    });
    const featureRows = customerIncludedFeatures.reduce((rowsByPair, feature, index) => {
        if (index % 2 === 0) {
            rowsByPair.push([feature]);
        } else {
            rowsByPair[rowsByPair.length - 1].push(feature);
        }
        return rowsByPair;
    }, []);
    const rowsHtml = rows.length > 0
        ? rows.map((row) => `
            <tr>
                <td style="width:${isInternetOnlyEmail ? '65%' : '50%'}; border-collapse:collapse; padding:8px 5px; border:1px solid #000000;">
                    <div style="text-align:left;">
                        <strong><span style="color:#555555; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px;">${escapeHtml(row.product)}</span></strong>
                        ${row.bullets?.length ? `<ul style="padding-left:20px; margin:6px 0 0;">${row.bullets.map((bullet) => `<li><span style="color:#555555; font-family:Arial, Helvetica, sans-serif; font-size:12px;">${escapeHtml(bullet)}</span></li>`).join('')}</ul>` : ''}
                    </div>
                </td>
                <td style="width:${isInternetOnlyEmail ? '35%' : '25%'}; border-collapse:collapse; border:1px solid #000000; padding:10px;">
                    <div style="text-align:center;"><strong><span style="color:#555555; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px;">${formatMoney(row.promo)}</span></strong></div>
                </td>
                ${isInternetOnlyEmail ? '' : `
                    <td style="width:25%; border-collapse:collapse; border:1px solid #000000; padding:10px;">
                        <div style="text-align:center;"><strong><span style="color:#555555; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px;">${row.regularLabel ? row.regularLabel.replace('/mo', '') : (row.regular === null ? 'N/A' : formatMoney(row.regular))}</span></strong></div>
                    </td>
                `}
            </tr>
        `).join('')
        : `
            <tr>
                <td colspan="${isInternetOnlyEmail ? 2 : 3}" style="padding:14px;border:1px solid #000000;color:#555555;font-family:Arial, Helvetica, sans-serif;font-size:14px;">
                    Select Internet, TV, or Home Phone to generate a Home Services offer preview.
                </td>
            </tr>
        `;
    const totalSavingsHtml = totalSavings
        ? `
            <table class="stylingblock-content-wrapper" style="min-width:100%; margin:0;" width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                    <tr>
                        <td style="padding:0;">
                            <table style="width:100%;" cellspacing="0" cellpadding="0">
                                <tbody>
                                    <tr>
                                        <td style="width:50%;" valign="top">&nbsp;</td>
                                        <td style="width:50%; padding-left:0;" valign="top">
                                            <table style="min-width:100%; margin:0; background-color:#258700;" width="100%" cellspacing="0" cellpadding="0">
                                                <tbody>
                                                    <tr>
                                                        <td style="padding:10px;">
                                                            <div style="text-align:center;"><strong><span style="color:#ffffff; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px;">Total Savings: ${formatMoney(totalSavings)}</span></strong></div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        `
        : '';
    const includedFeaturesSectionHtml = hasHomeServices
        ? `
            <tr>
                <td align="center">
                    <table border="0" width="540" cellspacing="0" cellpadding="0">
                        <tbody>
                            <tr>
                                <td style="padding:20px 0 0;" align="center">
                                    <table style="border-top:#ffffff 0 solid; min-width:100%; border-bottom:#ffffff 0 solid; background-color:#f5f6f8;" border="0" width="540" cellspacing="0" cellpadding="15" align="center">
                                        <tbody>
                                            <tr>
                                                <td style="text-align:left; color:#4b276d; font-family:Arial, Helvetica, sans-serif; font-size:18px;"><strong>Here's what else is included:</strong></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td style="padding:10px;">
                                    <table style="width:100%;" cellspacing="0" cellpadding="0">
                                        <tbody>
                                            ${featureRows.map((row) => `
                                                <tr>
                                                    ${row.length === 1
                                                        ? `
                                                            <td colspan="2" style="padding:0 4px 12px;" valign="top" align="center">
                                                                <table style="width:50%;" cellspacing="0" cellpadding="0">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td align="center"><img style="height:74px; width:75px; text-align:center; display:block; border:0; padding:0;" src="${row[0].icon}" width="75" height="74" alt=""></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><div style="text-align:center; color:#4b276d; font-family:Arial, Helvetica, sans-serif; font-size:20px; line-height:24px; padding:15px 8px;">${row[0].html}</div></td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        `
                                                        : row.map((feature) => `
                                                            <td style="width:50%; padding:0 4px 12px;" valign="top">
                                                                <table width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td align="center"><img style="height:74px; width:75px; text-align:center; display:block; border:0; padding:0;" src="${feature.icon}" width="75" height="74" alt=""></td></tr></tbody></table>
                                                                <div style="text-align:center; color:#4b276d; font-family:Arial, Helvetica, sans-serif; font-size:20px; line-height:24px; padding:15px 8px;">${feature.html}</div>
                                                            </td>
                                                        `).join('')}
                                                </tr>
                                            `).join('')}
                                            <tr>
                                                <td colspan="2" style="padding-top:10px;" align="center">
                                                    <img style="text-align:center; display:block; border:0; padding:0;" src="${activeEmailShell.critterImage}" width="270" height="auto" alt="">
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table style="border-top:#ffffff 0 solid; border-right:#ffffff 10px solid; min-width:100%; border-bottom:#ffffff 0 solid; border-left:#ffffff 10px solid;" border="0" width="540" cellspacing="0" cellpadding="15" align="center">
                                        <tbody>
                                            <tr>
                                                <td style="text-align:center; color:#4b276d; font-family:Arial, Helvetica, sans-serif; font-size:12px;">${selectedTv ? 'Additional PVR, digital boxes, and wireless modems can be obtained, monthly rental costs apply' : 'Additional wireless modems can be obtained, monthly rental costs apply'}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        `
        : '';
    const approvedTemplateFooterHtml = `
        <tr>
            <td align="center">
                <table style="line-height:1; border:1px solid rgb(245,246,247); min-width:600px; width:600px; margin-left:auto; margin-right:auto;" border="0" width="600" cellspacing="0" cellpadding="0" align="center">
                    <tbody>
                        <tr>
                            <td style="line-height:1; border-collapse:collapse; background-color:rgb(0,0,0);" align="center" valign="top">
                                <table style="line-height:1; min-width:100%; margin:10px 0 0; background-color:rgb(219,213,227);" width="100%" cellspacing="0" cellpadding="0">
                                    <tbody>
                                        <tr>
                                            <td style="line-height:1; border-collapse:collapse; padding:25px 40px;">
                                                <div style="text-align:center;">
                                                    <div><span style="color:rgb(74,42,108); font-size:30px; line-height:32px;">${escapeEmailText(activeEmailShell.agentContactHeadline || `Ready to sign up?\nHave more questions?`)}</span></div>
                                                    <div>&nbsp;</div>
                                                    <div><span style="color:rgb(74,42,108); font-size:20px; line-height:28px;">Agent Name: </span><span style="color:rgb(74,42,108); font-size:20px;">{{agent_name}}</span></div>
                                                    <div><span style="color:rgb(74,42,108); font-size:20px; line-height:28px;">Phone Number: {{agent_phone}}<br><span style="color:#4a2a6c; font-family:Arial, Helvetica, sans-serif;">${escapeEmailText(activeEmailShell.agentContactSubheadline || `Or\nReach Us at Our TELUS Store`)}: ${escapeHtml(activeEmailShell.storePhone)}</span></span></div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td style="line-height:1; border-collapse:collapse; padding:32px 0; background-color:rgb(0,0,0);" align="center">
                                <table style="line-height:1; width:646px;" border="0" width="438" cellspacing="0" cellpadding="0" align="center">
                                    <tbody>
                                        <tr>
                                            <td style="line-height:1; border-collapse:collapse; background-color:rgb(0,0,0); width:644px;" align="center">
                                                <table style="line-height:1;" border="0" width="171" cellspacing="0" cellpadding="0">
                                                    <tbody>
                                                        <tr>
                                                            <td style="line-height:1; border-collapse:collapse;">
                                                                <table style="line-height:1;" border="0" width="100%" cellspacing="0" cellpadding="0">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td style="line-height:1; border-collapse:collapse;" align="left">
                                                                                <a style="color:inherit;" href="${activeEmailShell.findStoreUrl}" target="_blank"><img style="outline:0; border:none; display:block;" src="${activeEmailShell.neighbourhoodIcon}" alt="Neighbourhood" width="41" height="41"></a>
                                                                            </td>
                                                                            <td style="line-height:1; border-collapse:collapse;" align="center">
                                                                                <a style="color:inherit;" href="https://www.facebook.com/TELUS" target="_blank"><img style="outline:0; border:none; display:block;" src="${activeEmailShell.facebookIcon}" alt="Facebook" width="42" height="41"></a>
                                                                            </td>
                                                                            <td style="line-height:1; border-collapse:collapse;" align="right">
                                                                                <a style="color:inherit;" href="https://twitter.com/TELUS" target="_blank"><img style="outline:0; border:none; display:block;" src="${activeEmailShell.twitterIcon}" alt="Twitter" width="42" height="41"></a>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="border-collapse:collapse; font-size:18px; line-height:34px; color:rgb(255,255,255); text-align:center; padding:25px 0 0; background-color:rgb(0,0,0); width:644px;" align="center">
                                                <div><a style="color:rgb(255,255,255); text-decoration-line:none;" href="${activeEmailShell.privacyUrl}" target="_blank">${escapeHtml(activeEmailShell.footerPrivacyText || 'Privacy')}</a> | <a style="color:rgb(255,255,255); text-decoration-line:none;" href="${activeEmailShell.contactUrl}" target="_blank">${escapeHtml(activeEmailShell.footerContactText || 'Contact Us')}</a></div>
                                                <div><a style="color:rgb(255,255,255); text-decoration-line:none;" href="${activeEmailShell.findStoreUrl}" target="_blank">${escapeHtml(activeEmailShell.footerFindStoreText || 'Find a Store')}</a> | <a style="color:rgb(255,255,255); text-decoration-line:none;" href="${activeEmailShell.telusUrl}" target="_blank">${escapeHtml(activeEmailShell.footerTelusText || 'telus.com')}</a></div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div><img src="${activeEmailShell.footerStoreImage}" alt="TELUS FutureGen Vancouver store listing" width="560" style="width:100%; max-width:560px; height:auto; display:block; margin:0 auto; border:0; outline:0;"></div>
                            </td>
                        </tr>
                        <tr>
                            <td style="line-height:1; border-collapse:collapse; width:99.6914%;" align="center">
                                <table style="line-height:1; background-color:rgb(245,246,247);" width="600" cellspacing="0" cellpadding="20">
                                    <tbody>
                                        <tr>
                                            <td style="border-collapse:collapse; font-size:10px; font-family:sans-serif; color:rgb(102,102,102); line-height:14px;">
                                                <table style="color:rgb(0,0,0); font-family:'Lato 2',sans-serif,system-ui,-apple-system,'Segoe UI',Roboto,Ubuntu,Cantarell,'Noto Sans',sans-serif; font-size:14px;" width="600" cellspacing="0" cellpadding="20">
                                                    <tbody>
                                                        <tr>
                                                            <td style="font-size:10px; font-family:sans-serif; color:rgb(102,102,102); line-height:14px;">
                                                                ${activeEmailShell.footerLegalHtml}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding:0 0 10px;" align="center">
                                                                <table border="0" width="540" cellspacing="0" cellpadding="0">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td style="height:1px; line-height:1px; font-size:1px;" height="1">&nbsp;</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="font-size:10px; font-family:sans-serif; color:rgb(102,102,102); line-height:14px;">
                                                                ${activeEmailShell.footerLegalFinePrintHtml}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </tr>
    `;

    const html = `
        <table class="email-container" style="min-width:600px; width:600px; margin-left:auto; margin-right:auto; background:#ffffff;" border="0" width="600" cellspacing="0" cellpadding="0" align="center">
            <tbody>
                <tr>
                    <td align="center">
                        <table class="width90" style="border-bottom:1px solid rgb(106,110,116);" border="0" width="540" cellspacing="0" cellpadding="0">
                            <tbody>
                                <tr>
                                    <td style="font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:21px; color:rgb(102,103,102); padding:20px 0 0;" align="center">&nbsp;</td>
                                </tr>
                                <tr>
                                    <td style="padding:20px 0;" align="center"><img src="${activeEmailShell.headerImage}" alt="TELUS Koodo Authorized Dealer" width="497" height="280" style="display:block;"></td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td style="text-align:center; font-family:Arial, Helvetica, sans-serif; color:#4a2a6c; font-size:48px; line-height:45px; padding:25px 25px 15px;">${escapeEmailText(activeEmailShell.introHeadline || `Look what\nyou could get.`)}</td>
                </tr>
                <tr>
                    <td align="center"><img class="mainimage" style="display:block;" src="${activeEmailShell.rabbitHeroImage}" width="530" height="auto" alt=""></td>
                </tr>
                <tr>
                    <td style="text-align:center; font-size:25px; font-family:Arial, Helvetica, sans-serif; color:#555555; line-height:35px; padding:5px 30px 20px;">
                        ${escapeEmailText(activeEmailShell.introSubheadline || `Here's a quick summary of the TELUS\nservices you're considering`)}
                        <div>From ${escapeHtml(activeEmailShell.storeName)}</div>
                        <div>Located at: ${formatStoreAddressEmailHtml(activeEmailShell)}</div>
                    </td>
                </tr>
                <tr>
                    <td align="center">
                        <table border="0" width="600" cellspacing="0" cellpadding="0">
                            <tbody>
                                <tr>
                                    <td style="padding:20px 0;" align="center"><img style="display:block;" src="${activeEmailShell.onboardingImage}" width="600" height="auto" alt=""></td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td style="padding:20px 0;" align="center">
                        <table class="width90" border="0" width="520" cellspacing="0" cellpadding="0">
                            <tbody>
                                <tr>
                                    <td style="text-align:left; font-size:22px; font-family:Arial, Helvetica, sans-serif; color:#4a2a6c; line-height:26px;" align="center">
                                        <span style="font-size:18px; font-family:Arial, Helvetica, sans-serif; color:#555555; line-height:26px;">
                                            ${escapeEmailText(activeEmailShell.customerIntroText || `Hi {{customer_first_name}},\n\nThanks for considering TELUS. As requested, here's a quote for the services we discussed. This quote is just for you, for services at the address you provided.`)}
                                        </span>
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td style="padding:10px 10px 40px;" align="center">
                        <table class="width90" border="0" width="520" cellspacing="0" cellpadding="0" align="center">
                            <tbody>
                                <tr>
                                    <td style="padding:20px;" align="center">
                                        <table class="width90" border="0" width="520" cellspacing="0" cellpadding="0" align="center">
                                            <tbody>
                                                <tr>
                                                    <td style="padding:10px;" align="center"><img style="display:block;" src="${activeEmailShell.personIcon}" width="50" height="auto" alt=""></td>
                                                </tr>
                                                <tr>
                                                    <td style="padding:5px 0; text-align:center; color:#444444; font-family:Arial, Helvetica, sans-serif; font-size:24px; line-height:28px;" align="center">Your details:</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td align="center">
                                        <table class="width90" border="0" width="540" cellspacing="0" cellpadding="0" align="center">
                                            <tbody>
                                                <tr>
                                                    <td style="width:30%; line-height:30px; text-align:left; color:#444444; font-family:Arial, Helvetica, sans-serif; font-size:18px;" valign="top"><strong>Name:</strong></td>
                                                    <td style="width:70%; line-height:30px; text-align:right; color:#444444; font-family:Arial, Helvetica, sans-serif; font-size:18px;" valign="top">{{customer_full_name}}</td>
                                                </tr>
                                                <tr>
                                                    <td style="width:30%; line-height:35px; text-align:left; color:#444444; font-family:Arial, Helvetica, sans-serif; font-size:18px;" valign="top"><strong>Email:</strong></td>
                                                    <td style="width:70%; text-align:right; color:#444444; font-family:Arial, Helvetica, sans-serif; font-size:18px; line-height:35px;" valign="top">{{customer_email}}</td>
                                                </tr>
                                                <tr>
                                                    <td style="width:30%; line-height:30px; text-align:left; color:#444444; font-family:Arial, Helvetica, sans-serif; font-size:18px;" valign="top"><strong>Phone number:</strong></td>
                                                    <td style="width:70%; line-height:30px; text-align:right; color:#444444; font-family:Arial, Helvetica, sans-serif; font-size:18px;" valign="top">{{customer_phone}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td align="center">
                        <table border="0" width="540" cellspacing="0" cellpadding="0">
                            <tbody>
                                <tr>
                                    <td style="padding:20px 0 0;" align="center">
                                        <table style="border-top:#ffffff 0 solid; min-width:100%; border-bottom:#ffffff 0 solid; background-color:#4b276d;" border="0" width="540" cellspacing="0" cellpadding="15" align="center">
                                            <tbody>
                                                <tr>
                                                    <td style="text-align:left; color:#ffffff; font-family:Arial, Helvetica, sans-serif; font-size:18px;"><strong>Here's what we talked about:</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td align="center">
                        <table border="0" width="600" cellspacing="0" cellpadding="0" align="center">
                            <tbody>
                                <tr>
                                    <td align="center" valign="top">
                                        <table border="0" width="540" cellspacing="0" cellpadding="0" align="center">
                                            <tbody>
                                                <tr>
                                                    <td align="center" valign="top">
                                                        <table class="stylingblock-content-wrapper" style="min-width:100%; margin:15px 0 0;" width="100%" cellspacing="0" cellpadding="0">
                                                            <tbody>
                                                                <tr>
                                                                    <td style="padding:10px;">
                                                                        <table style="width:100%;" cellspacing="0" cellpadding="0">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td style="width:${isInternetOnlyEmail ? '65%' : '50%'};">&nbsp;</td>
                                                                                    <td style="width:${isInternetOnlyEmail ? '35%' : '25%'}; text-align:center; color:#4b276d; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px; font-weight:bold;">${isInternetOnlyEmail ? 'Monthly price' : 'Promotional price'}</td>
                                                                                    ${isInternetOnlyEmail ? '' : '<td style="width:25%; text-align:center; color:#4b276d; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px; font-weight:bold;">Regular price</td>'}
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <table class="stylingblock-content-wrapper" style="min-width:100%; margin:0;" width="100%" cellspacing="0" cellpadding="0">
                                                            <tbody>
                                                                <tr>
                                                                    <td style="padding:0;">
                                                                        <table style="width:100%; border-collapse:collapse; border:1px solid #000000; padding:0;">
                                                                            <tbody>
                                                                                ${rowsHtml}
                                                                                <tr>
                                                                                    <td style="width:${isInternetOnlyEmail ? '65%' : '50%'}; border-collapse:collapse; padding-left:5px; background-color:#f8f5fc; border:1px solid #000000;">
                                                                                        <div style="text-align:left;"><strong><span style="color:#4b276d; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px;">TOTAL</span></strong></div>
                                                                                    </td>
                                                                                    <td style="width:${isInternetOnlyEmail ? '35%' : '25%'}; border-collapse:collapse; background-color:#f8f5fc; border:1px solid #000000; padding:10px;">
                                                                                        <div style="text-align:center;"><strong><span style="color:#4b276d; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px;">${formatMoney(homeSubtotal)}</span></strong></div>
                                                                                    </td>
                                                                                    ${isInternetOnlyEmail ? '' : `
                                                                                        <td style="width:25%; border-collapse:collapse; background-color:#f8f5fc; border:1px solid #000000; padding:10px;">
                                                                                            <div style="text-align:center;"><strong><span style="color:#4b276d; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px;">${formatMoney(regularTotal)}</span></strong></div>
                                                                                        </td>
                                                                                    `}
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        ${totalSavingsHtml}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td align="center">
                        <table style="border-top:#ffffff 0 solid; min-width:100%; border-bottom:#ffffff 0 solid;" border="0" width="540" cellspacing="0" cellpadding="15" align="center">
                            <tbody>
                                <tr>
                                    <td style="text-align:left; color:#555555; font-family:Arial, Helvetica, sans-serif; font-size:14px;">
                                        <div>*<em>Above prices do not include tax. Commitment term required.</em></div>
                                        ${discountFootnote ? `<div style="margin-top:6px; color:#555555; font-family:Arial, Helvetica, sans-serif; font-size:12px; line-height:16px;"><em>${escapeHtml(discountFootnote)}</em></div>` : ''}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table border="0" width="540" cellspacing="0" cellpadding="0" align="center">
                            <tbody>
                                <tr>
                                    <td style="padding:0 0 20px;">
                                        <table style="width:100%;">
                                            <tbody>
                                                <tr>
                                                    <td style="width:40%;"><strong><span style="color:#4b276d; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px;">Accessories &amp; Other</span></strong></td>
                                                    <td style="width:10%;"><strong><span style="color:#4b276d; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px;">Qty:</span></strong></td>
                                                    <td style="width:25%;"><strong><span style="color:#4b276d; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px;">Total price:</span></strong></td>
                                                    <td style="width:25%;"><strong><span style="color:#4b276d; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px;">Easy payment:</span></strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table style="width:100%; border-collapse:collapse; border:1px solid #000000; padding:0;">
                                            <tbody>
                                                <tr>
                                                    <td style="width:40%; border-collapse:collapse; padding-left:5px; border:1px solid #000000;"><div style="text-align:left;"><strong><span style="color:#555555; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px;">Installation and Other Charges</span></strong></div></td>
                                                    <td style="width:10%; border-collapse:collapse; border:1px solid #000000; padding:10px;"><div style="text-align:center;"><strong><span style="color:#555555; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px;">1</span></strong></div></td>
                                                    <td style="width:25%; border-collapse:collapse; border:1px solid #000000; padding:10px;"><div style="text-align:center;"><strong><span style="color:#555555; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px;">$0</span></strong></div></td>
                                                    <td style="width:25%; border-collapse:collapse; border:1px solid #000000; padding:10px;"><div style="text-align:center;"><strong><span style="color:#555555; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:16px;">One Time Payment</span></strong></div></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                ${includedFeaturesSectionHtml}
                ${approvedTemplateFooterHtml}
            </tbody>
        </table>
    `;

    const plainRows = rows.length > 0
        ? rows.map((row) => {
            const bulletText = row.bullets?.length ? `; ${row.bullets.join(', ')}` : '';
            const regularText = row.regularLabel || (row.regular === null ? 'N/A' : `${formatMoney(row.regular)}/mo`);
            return `- ${row.product}${bulletText}: ${formatMoney(row.promo)}/mo; regular ${regularText}`;
        })
        : ['- Select Internet, TV, or Home Phone to generate a Home Services offer preview.'];
    const plainText = [
        'Your TELUS Home Services Quote',
        '',
        'Hi {{customer_first_name}}, here is the quote we prepared for you.',
        '',
        'Customer details:',
        'Name: {{customer_full_name}}',
        'Email: {{customer_email}}',
        'Phone: {{customer_phone}}',
        '',
        'Quote details:',
        ...plainRows,
        '',
        `Estimated monthly total: ${formatMoney(homeSubtotal)}/mo`,
        totalSavings ? `Total Savings over 24 months: ${formatMoney(totalSavings)}` : null,
        hasCurrentMonthlyBill ? `Savings comparison: current bill ${formatMoney(currentMonthlyBill)}/mo, new Home Services quote ${formatMoney(homeSubtotal)}/mo.` : null,
        billCredit ? `One-time bill credit: ${formatMoney(billCredit)}` : null,
        '',
        'Included features:',
        ...customerIncludedFeatures.map((feature) => `- ${feature.label}`),
        '',
        'Your TELUS contact:',
        'Agent: {{agent_name}}',
        'Phone: {{agent_phone}}',
        `Store: ${activeEmailShell.storeName}`,
        `Store phone: ${activeEmailShell.storePhone}`,
        '',
        'Pricing, credits, installation windows, taxes, serviceability, and eligibility are subject to final TELUS approval.'
    ].filter(Boolean).join('\n');

    return {
        html,
        plainText,
        warnings: uniqueInternalWarnings,
        hasHomeServices
    };
}
